import LoadingScreen from "@/components/LoadingScreen";
import { useImproveLoading, useHasImproveInitialized } from "@/store";
import { FloatingSidebarLayout } from "@/components/flow/shared/FullScreenModal";

export function ImproveLayout({
    Sidebar,
    VisualArea,
    BottomContent
}: {
    Sidebar?: React.ReactNode;
    VisualArea: React.ReactNode;
    BottomContent?: React.ReactNode;
}) {
    const loading = useImproveLoading();
    const hasInitialized = useHasImproveInitialized();

    if (loading || !hasInitialized) {
        return <LoadingScreen message="Loading images to review..." />;
    }

    return (
        <FloatingSidebarLayout
            VisualArea={VisualArea}
            Sidebar={Sidebar}
            BottomContent={BottomContent}
        />
    );
}
